const API_URL = process.env.REACT_APP_API_URL;

const baseUrl = window.location.origin.length > 0 ? window.location.origin : "";

export { baseUrl, API_URL };